export default __webpack_public_path__ + "static/media/payment-apple-pay.0fbe8c6c.svg";